export default class TestWebMAlphaSupport {
	async apply() {
		const supported = await this.test();

		if (supported) {
			document.body.classList.add('webm-alpha-supported');
		} else {
			document.body.classList.remove('webm-alpha-supported');
		}
	}

	test() {
		return new Promise((resolve, reject) => {
			var vid = document.createElement('video');
			vid.autoplay = false;
			vid.loop = false;
			vid.style.display = 'none';

			vid.addEventListener('loadeddata', () => {
				document.body.removeChild(vid);
				// Create a canvas element, this is what user sees.
				var canvas = document.createElement('canvas');

				//If we don't support the canvas, we definitely don't support webm alpha video.
				if (!(canvas.getContext && canvas.getContext('2d'))) {
					resolve(false);
				}

				// Get the drawing context for canvas.
				var ctx = canvas.getContext('2d');

				// Draw the current frame of video onto canvas.
				ctx.drawImage(vid, 0, 0);
				if (ctx.getImageData(0, 0, 1, 1).data[3] === 0) {
					resolve(true);
				} else {
					resolve(false);
				}
			});

			vid.addEventListener('error', function () {
				try {
					document.body.removeChild(vid);
				} catch (e) {
					//ignore the failure
				}
				resolve(false);
			});

			vid.addEventListener('stalled', function () {
				document.body.removeChild(vid);
				resolve(false);
			});

			//Just in case
			vid.addEventListener('abort', function () {
				if (document.body.contains(vid)) {
					document.body.removeChild(vid);
				}
				resolve(false);
			});

			var source = document.createElement('source');
			source.src =
				'data:video/webm;base64,GkXfowEAAAAAAAAfQoaBAUL3gQFC8oEEQvOBCEKChHdlYm1Ch4ECQoWBAhhTgGcBAAAAAAACBRFNm3RALE27i1OrhBVJqWZTrIHlTbuMU6uEFlSua1OsggEjTbuMU6uEHFO7a1OsggHo7AEAAAAAAACqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmAQAAAAAAADIq17GDD0JATYCNTGF2ZjU3LjU3LjEwMFdBjUxhdmY1Ny41Ny4xMDBEiYhARAAAAAAAABZUrmsBAAAAAAAARq4BAAAAAAAAPdeBAXPFgQGcgQAitZyDdW5khoVWX1ZQOYOBASPjg4QCYloA4AEAAAAAAAARsIFAuoFAmoECU8CBAVSygQQfQ7Z1AQAAAAAAAGfngQCgAQAAAAAAAFuhooEAAACCSYNCAAPwA/YAOCQcGFQAADBgAABnP///NXgndmB1oQEAAAAAAAAtpgEAAAAAAAAk7oEBpZ+CSYNCAAPwA/YAOCQcGFQAADBgAABnP///Vttk7swAHFO7awEAAAAAAAARu4+zgQC3iveBAfGCAXXwgQM=';
			source.addEventListener('error', function () {
				document.body.removeChild(vid);
				resolve(false);
			});
			vid.appendChild(source);

			//This is required for IE
			document.body.appendChild(vid);

			//If the video doesn't load in 1 second, we assume it's not supported.

			setTimeout(() => {
				resolve(false);
			}, 1000);
		});
	}
}
